import {register} from '../modules/eventMap';

const update = (el) => {
    const {subdomainTargetSelector} = el.dataset;
    const target = document.querySelector(subdomainTargetSelector);
    target.value = el.value.replaceAll(' ', '').toLowerCase();
};

const subdomainFromString = () => {
    register('subdomainFromString', {
        update
    });
};

export {subdomainFromString};
